export const timePosted = (date: string): string => {
  const now = new Date();
  const diffInSeconds = Math.floor(
    (now.getTime() - new Date(date).getTime()) / 1000
  );

  const minute = 60;
  const hour = 60 * minute;
  const day = 24 * hour;
  const week = 7 * day;
  const month = 30 * day;
  const year = 365 * day;

  if (diffInSeconds < minute) {
    return `${diffInSeconds} s`;
  } else if (diffInSeconds < hour) {
    return `${Math.floor(diffInSeconds / minute)} m`;
  } else if (diffInSeconds < day) {
    return `${Math.floor(diffInSeconds / hour)} h`;
  } else if (diffInSeconds < week) {
    return `${Math.floor(diffInSeconds / day)} d`;
  } else if (diffInSeconds < month) {
    return `${Math.floor(diffInSeconds / week)} w`;
  } else {
    return `${Math.floor(diffInSeconds / year)} y`;
  }
};

export const shortName = (fullName: string | null | undefined): string => {
  // Check if fullName is valid (not null or undefined)
  if (!fullName) {
    return ""; // Return an empty string if fullName is null or undefined
  }

  // Split the full name into an array of words
  const nameParts = fullName.split(" ");

  // If there are more than two parts, return the first two parts
  if (nameParts.length > 2) {
    return nameParts.slice(0, 2).join(" ");
  }

  // Otherwise, return the full name
  return fullName;
};
